// 重连时恢复设备码配对所需的短期凭据。
// 初次配对成功后，当前配对消息会主动去掉密码，避免长期挂在可复用消息对象上；
// 但同一会话的自动重连仍需要它，因此只在真正重发前创建一次性副本。

export function restoreGuestPairPassword(pairMessage: unknown, password: string | null): unknown {
  if (!password || typeof pairMessage !== 'object' || pairMessage === null || Array.isArray(pairMessage)) {
    return pairMessage;
  }
  const message = pairMessage as Record<string, unknown>;
  if (message.type !== 'guest-pair' || typeof message.password === 'string') return pairMessage;
  return { ...message, password };
}

